import {Component, OnInit} from '@angular/core';
import {Ref} from '../../shared/models/referencia.model';
import {Servidor} from '../../shared/models/servidor.model';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ConfigService} from '../../config/config.service';
import {HandleError} from '../../http-error-handler.service';
import {Observable} from 'rxjs';
import {LOCALE_ID} from '@angular/core';

import {ActivatedRoute} from '@angular/router';

import {CategoriaModel} from '../../shared/models/categoria.model';
import {async} from 'q';
import {NgxSpinnerService} from 'ngx-spinner';
import {LotacaoModel} from '../../shared/models/lotacao.model';

@Component({
  selector: 'app-pesquisa',
  templateUrl: './pesquisa.component.html',
  styleUrls: ['./pesquisa.component.css']
})
export class PesquisaComponent implements OnInit {

  servidor: Servidor;
  private handleError: HandleError;
  title = 'Transparecia';
  servico: ConfigService;
  nomeDigitado: string;
  private lotacaoDigitada: string;
  name: string;
  isVisible: boolean;
  isEnable: boolean;
  raizCnpj: string;

  datRef: string;
  referencia: Ref[] = [];
  categoria: CategoriaModel[] = [];
  lotacao: LotacaoModel[] = [];
  detalhes = [];
  servidores: Servidor[] = [];

  // urlBase: String = 'http://localhost:8080/api';
  configUrlPessoa = '/listapessoas/100/0/20';
  // configUrlReferncia = '/buscaReferencia';
  urlNode = 'http://localhost:3838/publica/api/11111111/pesq';
  urlNodeRef = 'http://localhost:3838/publica/api/11111111/buscaReferencia';
  urlNodeCat = 'http://localhost:3838/publica/api/11111111/listaCategoria';
  urlNodeLot = 'http://localhost:3838/publica/api/11111111/listaLotacao';
  urlNodeDetalhe = 'http://localhost:3838/publica/api/11111111/detalhaMovimento';
  private mensagem: string;
  private cargo: string;


  constructor(private route: ActivatedRoute, private http: HttpClient, private spinner: NgxSpinnerService) {

    this.isVisible = false;
    this.isEnable = true;
    this.name = '';
    this.raizCnpj = undefined;
    this.route.params.subscribe(res => this.raizCnpj = res.raiz);
    this.raizCnpj = '66482084000155';
    if (this.raizCnpj !== undefined) {
      // this.urlNode =  `http://localhost:3838/publica/api/${this.raizCnpj}/pesq`;
      // this.urlNodeRef = `http://localhost:3838/publica/api/${this.raizCnpj}/buscaReferencia`;
      // this.urlNodeCat = `http://localhost:3838/publica/api/${this.raizCnpj}/listaCategoria`;
      // this.urlNodeLot = `http://localhost:3838/publica/api/${this.raizCnpj}/listaLotacao`;
      // this.urlNodeDetalhe = `http://localhost:3838/publica/api/${this.raizCnpj}/detalhaMovimento`;
      //
      this.urlNode = `http://www.escaltecnologia.com.br/icarai/api/${this.raizCnpj}/pesq`;
      this.urlNodeRef = `http://www.escaltecnologia.com.br/icarai/api/${this.raizCnpj}/buscaReferencia`;
      this.urlNodeCat = `http://www.escaltecnologia.com.br/icarai/api/${this.raizCnpj}/listaCategoria`;
      this.urlNodeLot = `http://www.escaltecnologia.com.br/icarai/api/${this.raizCnpj}/listaLotacao`;
      this.urlNodeDetalhe = `http://www.escaltecnologia.com.br/icarai/api/${this.raizCnpj}/detalhaMovimento`;
    }
  }


  ngOnInit() {

    if ((this.raizCnpj !== undefined) || (this.raizCnpj !== '')) {
      this.mensagem = 'É necessário informar a raiz do CNPJ!!!';
    }
    if ((this.raizCnpj !== undefined) && (this.raizCnpj !== '')) {
      this.getReferencia().subscribe(data => {
        this.referencia = data;
      });

      // this.getCategoria().subscribe(data => {
      //   this.categoria = data;
      // });

      // this.getCategoria().then(response => {
      //   response.json().then( data => this.categoria = data).catch(err => console.log('Não encontrado'))
      // }).catch();

      this.infLotacao();
      this.infCategoria();
      this.spinner.hide();
    }
  }


  async infLotacao() {
    const response = await this.getLotcao();
    const data = await response.json();
    this.lotacao = data;
  }

  async infCategoria() {
    const response = await this.getCategoria();
    const data = await response.json();
    this.categoria = data;
  }

  /** GET heroes from the server */
  getServidor(digitado: string, cargo: string, matricula: string, valorReferencia: string, valorCategoria: string, valorLotacao: string): Observable<Servidor[]> {
    this.spinner.show();
    if ((digitado === undefined) || (digitado === ' ')  || (digitado === '')) {
      digitado = '%20';
    }
    if ((cargo === undefined) || (cargo === ' ') || (cargo === '')) {
      cargo = '%20';
    }
    if ((matricula === undefined) || (matricula === ' ') || (matricula === '')) {
      matricula = '%20';
    }

    if ((valorCategoria === undefined) || (valorCategoria === ' ') || (valorCategoria === 'Categoria')) {
      valorCategoria = '%20';
    }

    if ((valorLotacao === undefined) || (valorLotacao === ' ') || (valorLotacao === 'Lotação')) {
      valorLotacao = '%20';
    }
    if ((valorReferencia === undefined) || (valorReferencia === ' ') || (valorReferencia === '')) {
      valorReferencia = '%20';
    }

    // :nome?/:matricula?/:cargo?/:ref?/:cat?/:lot
    //http://www.escaltecnologia.com.br/icarai/api/66482084000155/pesq/%20/%20/%20/202104/%20/
    let url = `${this.urlNode}/${digitado}/${matricula}/${cargo}/${valorReferencia}/${valorCategoria}/${valorLotacao}`;
    console.log(url)
    return this.http.get<Servidor[]>(url);
    // return this.http.get<Servidor[]>(`${this.urlBase}${this.configUrlPessoa}/${digitado}`);
  }

  /** GET heroes from the server */
  getReferencia(): Observable<Ref[]> {
    this.spinner.show();
    // return this.http.get<Referencia[]>(this.urlBase + this.configUrlReferncia);
    return this.http.get<Ref[]>(this.urlNodeRef);
  }

  buscaServidor(digitado: string, cargo: string, matricula: string, valorReferencia: string, valorCategoria: string, valorLotacao: string) {
    this.nomeDigitado = digitado;
    this.cargo = cargo;
    this.datRef = valorReferencia;
    this.lotacaoDigitada = valorLotacao;
    this.getServidor(digitado, cargo, matricula, valorReferencia, valorCategoria, valorLotacao).subscribe(pessoas => {
      this.servidores = pessoas;
      this.isVisible = true;
      this.spinner.hide();
    });
    // if (this.servidores) {
    //   this.isVisible = true;
    // } else {
    //   this.isVisible = false;
    // }
  }

  preenchido(parametro: string): boolean {
    this.name = parametro;
    this.isEnable = true; //parametro.length < 5;
    this.isVisible = false;
    // this.isVisible = parametro.length >= 5;
    this.servidores = [];
    return this.isEnable;
  }

  // private getCategoria(): Observable< CategoriaModel[] > {
  //     return this.http.get<CategoriaModel[]>(this.urlNodeCat);
  // }

  private getCategoria() {
    this.spinner.show();
    return fetch(this.urlNodeCat);
  }

  private getLotcao() {
    this.spinner.show();
    return fetch(this.urlNodeLot);
  }


  private getMovimento(codFnc: number, datref: string, codEmp: number) {
    this.spinner.show();
    return fetch(`${this.urlNodeDetalhe}/${codFnc}/${datref}/${codEmp}`);
  }


  async detalhaServidor(codFnc: number, codEmp: number) {
    const response = await this.getMovimento(codFnc, this.datRef, codEmp);
    const data = await response.json();
    this.detalhes = data;
    this.spinner.hide();
  }

  escondeDetalhes(number: number) {
    this.detalhes = [];
  }

  hasNoSelectedServidores() {
    return this.servidores.length === 0;
  }

  hasNoSelectedDetalhes(mat: number) {
    for (let det in this.detalhes) {
      return this.detalhes[det].MATRICULA == mat;
    }
    return false;
  }

}
